import selectdevtools from "../../../../assets/images/docs/select-devtools.png";
import pickdevtools from "../../../../assets/images/docs/devtools/pickdevtools.png";
import { Code } from 'react-bytesize-icons';
import * as React from 'react';
export default {
  selectdevtools,
  pickdevtools,
  Code,
  React
};